export default "__VITE_ASSET__Pbo1RR8D__"